/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdjustmentAdminDto } from '../models/AdjustmentAdminDto';
import type { Pagination1OfAdjustmentAdminListedDto } from '../models/Pagination1OfAdjustmentAdminListedDto';
import type { Pagination1OfAdjustmentDriverDto } from '../models/Pagination1OfAdjustmentDriverDto';
import type { PostAdjustmentAdminRequest } from '../models/PostAdjustmentAdminRequest';
import type { PutAdjustmentAdminRequest } from '../models/PutAdjustmentAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdjustmentsService {
    /**
     * @returns Pagination1OfAdjustmentDriverDto OK
     * @throws ApiError
     */
    public static getAvailableAdjustmentsDriver({
        validFrom,
        validTo,
        page,
        limit,
    }: {
        validFrom?: string,
        validTo?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfAdjustmentDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/adjustments',
            query: {
                'validFrom': validFrom,
                'validTo': validTo,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewAdjustments`
     * @returns Pagination1OfAdjustmentAdminListedDto OK
     * @throws ApiError
     */
    public static getAdjustmentsAdmin({
        validFrom,
        validTo,
        driverName,
        searchWord,
        page,
        limit,
    }: {
        validFrom?: string,
        validTo?: string,
        driverName?: string,
        searchWord?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfAdjustmentAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/adjustments',
            query: {
                'validFrom': validFrom,
                'validTo': validTo,
                'driverName': driverName,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageAdjustments`
     * @returns AdjustmentAdminDto OK
     * @throws ApiError
     */
    public static createAdjustmentAdmin({
        requestBody,
    }: {
        requestBody?: PostAdjustmentAdminRequest,
    }): CancelablePromise<AdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/adjustments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewAdjustmentDetails`
     * @returns AdjustmentAdminDto OK
     * @throws ApiError
     */
    public static getAdjustmentAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<AdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/adjustments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageAdjustments`
     * @returns AdjustmentAdminDto OK
     * @throws ApiError
     */
    public static updateAdjustmentAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutAdjustmentAdminRequest,
    }): CancelablePromise<AdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/adjustments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteAdjustments`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteAdjustmentAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/adjustments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
